<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.factories'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>

    <div class="wrapper table-area">
      <vxe-table
        :data="factories"
        :loading="loading"
        id="phaseGroupTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('text.name')">
          <template v-slot="{ row }">
            <a @click="showRow(row)">{{ row.name }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="xcxViewImages"
          :title="$t('factory.xcxViewImages')"
        >
          <template v-slot="{ row }">{{
            $t("boolean." + row.xcxViewImages)
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="xcxViewPhasePrice"
          :title="$t('factory.xcxViewPhasePrice')"
        >
          <template v-slot="{ row }">{{
            $t("boolean." + row.xcxViewPhasePrice)
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.currentTenant().config.mesSchedule == true"
          field="bulkCapacity"
          :title="$t('factory.bulkCapacity')"
        />
        <vxe-table-column
          v-if="Permit.currentTenant().config.mesSchedule == true"
          field="customCapacity"
          :title="$t('factory.customCapacity')"
        />
        <vxe-table-column
          v-if="Permit.currentTenant().config.mesSchedule == true"
          field="redundancyPercent"
          :title="$t('factory.redundancyPercent')"
        >
          <template v-slot="{ row }"> {{ row.redundancyPercent }}% </template>
        </vxe-table-column>
        <vxe-table-column
          :title="$t('factory.yearHoliday')"
          v-if="Permit.currentTenant().config.mesSchedule == true"
        >
          <template v-slot="{ row }">
            {{ computeHoliday(row.nonWork, "yearHoliday").join(",") }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          :title="$t('factory.monthHoliday')"
          v-if="Permit.currentTenant().config.mesSchedule == true"
        >
          <template v-slot="{ row }">
            {{ computeHoliday(row.nonWork, "monthHoliday").join(",") }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          :title="$t('factory.weekHoliday')"
          v-if="Permit.currentTenant().config.mesSchedule == true"
        >
          <template v-slot="{ row }">
            {{ computeHoliday(row.nonWork, "weekHoliday").join(",") }}
          </template>
        </vxe-table-column>

        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
            <div v-if="Permit.currentTenant().config.mesSchedule == true">
              <el-button type="text" size="mini" @click="copySchedule(row)">{{
                $t("action.copySchedule")
              }}</el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRecordId" />
    </drawer>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="50%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="90px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="10">
              <el-form-item
                :label="$t('text.name')"
                :prop="'name'"
                :rules="[
                  { required: true, validator: validateName, trigger: 'blur' },
                ]"
                label-width="60px"
              >
                <el-input size="small" v-model.trim="addObj.name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('factory.xcxViewImages')"
                :prop="'xcxViewImages'"
              >
                <el-checkbox size="small" v-model="addObj.xcxViewImages" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('factory.xcxViewPhasePrice')"
                :prop="'xcxViewPhasePrice'"
                label-width="90px"
              >
                <el-checkbox size="small" v-model="addObj.xcxViewPhasePrice" />
              </el-form-item>
            </el-col>
          </el-row>
          <div
            v-if="Permit.currentTenant().config.mesSchedule == true"
            :class="
              Permit.currentTenant().config.mesSchedule == true
                ? 'search-condition-div'
                : ''
            "
          >
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('factory.bulkCapacity')"
                  :prop="'bulkCapacity'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('factory.bulkCapacity'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="addObj.bulkCapacity"
                    @blur="addScheduleBlur"
                  >
                    <template slot="append"
                      >+ {{ addBulkCapacityAdd }}</template
                    >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('factory.customCapacity')"
                  :prop="'customCapacity'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('factory.customCapacity'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="addObj.customCapacity"
                    @blur="addScheduleBlur"
                  >
                    <template slot="append"
                      >+ {{ addCustomCapacityAdd }}</template
                    >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('factory.redundancyPercent')"
                  :prop="'redundancyPercent'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('factory.redundancyPercent'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="addObj.redundancyPercent"
                    @blur="addScheduleBlur"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('factory.yearHoliday')">
              <el-date-picker
                style="width: 100%"
                size="small"
                type="dates"
                v-model="addSelectNonWork.yearHoliday.list"
                placeholder="选择一个或多个日期"
                :picker-options="pickerCurrentYearTime"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('factory.monthHoliday')">
              <el-select
                size="small"
                v-model="addSelectNonWork.monthHoliday.list"
                clearable
                filterable
                multiple
                placeholder="选择一个或多个"
              >
                <el-option
                  v-for="month in months"
                  :key="month.value"
                  :label="month.label"
                  :value="month.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('factory.weekHoliday')">
              <el-select
                size="small"
                v-model="addSelectNonWork.weekHoliday.list"
                clearable
                filterable
                multiple
                placeholder="选择一个或多个"
              >
                <el-option
                  v-for="week in weeks"
                  :key="week.value"
                  :label="week.label"
                  :value="week.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <!-- <el-row :gutter="5">
              <el-col :span="4">
                <el-form-item :prop="'yearHoliday'" label-width="0px">
                  <el-checkbox
                    size="small"
                    v-model="addSelectNonWork.yearHoliday.open"
                  >
                    {{ $t("factory.yearHoliday") }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('factory.yearHoliday')">
                  <el-date-picker
                    style="width: 100%"
                    size="small"
                    type="dates"
                    v-model="addSelectNonWork.yearHoliday.list"
                    placeholder="选择一个或多个日期"
                    :picker-options="pickerCurrentYearTime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="4">
                <el-form-item :prop="'monthHoliday'" label-width="0px">
                  <el-checkbox
                    size="small"
                    v-model="addSelectNonWork.monthHoliday.open"
                  >
                    {{ $t("factory.monthHoliday") }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-select
                  size="small"
                  v-model="addSelectNonWork.monthHoliday.list"
                  clearable
                  filterable
                  multiple
                  placeholder="选择一个或多个"
                >
                  <el-option
                    v-for="month in months"
                    :key="month.value"
                    :label="month.label"
                    :value="month.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="4">
                <el-form-item :prop="'weekHoliday'" label-width="0px">
                  <el-checkbox
                    size="small"
                    v-model="addSelectNonWork.weekHoliday.open"
                  >
                    {{ $t("factory.weekHoliday") }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-select
                  size="small"
                  v-model="addSelectNonWork.weekHoliday.list"
                  clearable
                  filterable
                  multiple
                  placeholder="选择一个或多个"
                >
                  <el-option
                    v-for="week in weeks"
                    :key="week.value"
                    :label="week.label"
                    :value="week.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row> -->
          </div>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("factory.user") }}</legend>
          <el-checkbox-group size="small" v-model="checkedUserIds">
            <el-checkbox
              v-for="user of users"
              :key="user.id"
              :label="user.id"
              >{{ user.name }}</el-checkbox
            >
          </el-checkbox-group>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("factory.phaseAndPrice") }}</legend>
          <vxe-table
            :data="phasePrices"
            class="recordsTable"
            size="mini"
            resizable
            round
            highlight-hover-row
            auto-resize
            border
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column field="phaseName" :title="$t('menu.phases')" />
            <vxe-table-column
              field="phasePrice"
              :title="$t('factory.phasePrice')"
            >
              <template v-slot="{ row }">
                <el-input size="small" v-model.trim="row.phasePrice" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="action"
              :title="$t('text.action')"
              width="50"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button type="text" size="mini" @click="remove(rowIndex)">{{
                  $t("text.remove")
                }}</el-button>
              </template>
            </vxe-table-column>
          </vxe-table>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="90px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label-width="60px"
              :label="$t('text.name')"
              :prop="'name'"
              :rules="[
                {
                  required: true,
                  validator: validateNameEdit,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('factory.xcxViewImages')"
              :prop="'xcxViewImages'"
            >
              <el-checkbox size="small" v-model="editObj.xcxViewImages" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('factory.xcxViewPhasePrice')"
              :prop="'xcxViewPhasePrice'"
            >
              <el-checkbox size="small" v-model="editObj.xcxViewPhasePrice" />
            </el-form-item>
          </el-col>
        </el-row>
        <div
          v-if="Permit.currentTenant().config.mesSchedule == true"
          :class="
            Permit.currentTenant().config.mesSchedule == true
              ? 'search-condition-div'
              : ''
          "
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('factory.bulkCapacity')"
                :prop="'bulkCapacity'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('factory.bulkCapacity')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="editObj.bulkCapacity"
                  @blur="editScheduleBlur"
                >
                  <template slot="append">+ {{ editBulkCapacityAdd }}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('factory.customCapacity')"
                :prop="'customCapacity'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('factory.customCapacity'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="editObj.customCapacity"
                  @blur="editScheduleBlur"
                >
                  <template slot="append"
                    >+ {{ editCustomCapacityAdd }}</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('factory.redundancyPercent')"
                :prop="'redundancyPercent'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('factory.redundancyPercent'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="editObj.redundancyPercent"
                  @blur="editScheduleBlur"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$t('factory.yearHoliday')">
            <el-date-picker
              style="width: 100%"
              size="small"
              type="dates"
              v-model="editSelectNonWork.yearHoliday.list"
              placeholder="选择一个或多个日期"
              :picker-options="pickerCurrentYearTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('factory.monthHoliday')">
            <el-select
              size="small"
              v-model="editSelectNonWork.monthHoliday.list"
              clearable
              filterable
              multiple
              placeholder="选择一个或多个"
            >
              <el-option
                v-for="month in months"
                :key="month.value"
                :label="month.label"
                :value="month.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('factory.weekHoliday')">
            <el-select
              size="small"
              v-model="editSelectNonWork.weekHoliday.list"
              clearable
              filterable
              multiple
              placeholder="选择一个或多个"
            >
              <el-option
                v-for="week in weeks"
                :key="week.value"
                :label="week.label"
                :value="week.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.copySchedule')"
      :close-on-click-modal="false"
      :visible.sync="copyScheduleDF"
      width="50%"
    >
      <el-form
        ref="copyScheduleObjForm"
        :model="copyScheduleObj"
        label-width="90px"
      >
        <div class="mgb15">
          <el-checkbox
            v-model="checkAllFactory"
            :indeterminate="isIndeterminateFactory"
            @change="handleCheckAllChangeFactory"
          >
            {{ $t("action.checkAll") }}
          </el-checkbox>
          <el-form-item
            :label="$t('menu.factories')"
            :prop="'ids'"
            :rules="[
              {
                required: true,
                message: $t('rules.select', [$t('menu.factories')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-checkbox-group
              v-model="copyScheduleObj.ids"
              @change="handleCheckedChangeFactory"
            >
              <el-checkbox
                v-for="factory of copyScheduleFactories"
                :key="factory.id"
                :label="factory.id"
              >
                {{ factory.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="copyScheduleSubmitDoing"
          size="small"
          @click="copyScheduleSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="copyScheduleDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Util from "@/utils/index.js";
import { page } from "@/utils/mixins.js";
import { weeks } from "@/utils/enums.js";
import Show from "./show.vue";
import Factory from "@/api/factory.js";
import User from "@/api/user.js";
import Phase from "@/api/phase.js";

export default {
  mixins: [page],
  components: { Show },
  data() {
    var validateName = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(new Error(self.$t("rules.required", [self.$t("text.name")])));
        return;
      }

      if (self.factories.find((f) => f.name === value) != null) {
        callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(new Error(self.$t("rules.required", [self.$t("text.name")])));
        return;
      }
      if (
        self.factories.filter((s) => s.name === value).length > 0 &&
        !(value === self.row.name)
      ) {
        callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    return {
      Util: Util,
      factories: [],
      //
      showDF: false,
      currentRecordId: null,
      // 新增
      validateName: validateName,
      addDF: false,
      phasePrices: [],
      users: [],
      addObj: {
        name: null,
        xcxViewImages: false,
        xcxViewPhasePrice: false,
        factoryPhases: [],
        userFactories: [],
        bulkCapacity: null,
        customCapacity: null,
        redundancyPercent: null,
        nonWork: null,
      },
      checkedPhases: [],
      checkedUserIds: [],
      addDoing: false,
      addBulkCapacityAdd: 0,
      addCustomCapacityAdd: 0,
      addSelectNonWork: {
        yearHoliday: {
          open: false,
          list: [], // 存日期字符串 01-01, ....12-31
        },
        monthHoliday: {
          open: false,
          list: [], // 存日期字符串 1，2，3....,30 31
        },
        weekHoliday: {
          open: false,
          list: [], // 1:周一 类推 7: 周日
        },
      },
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        xcxViewImages: null,
        xcxViewPhasePrice: null,
        bulkCapacity: null,
        customCapacity: null,
        redundancyPercent: null,
      },
      editBulkCapacityAdd: 0,
      editCustomCapacityAdd: 0,
      editSelectNonWork: {
        yearHoliday: {
          open: false,
          list: [], // 存日期字符串 01-01, ....12-31
        },
        monthHoliday: {
          open: false,
          list: [], // 存日期字符串 1，2，3....,30 31
        },
        weekHoliday: {
          open: false,
          list: [], // 1:周一 类推 7: 周日
        },
      },
      pickerCurrentYearTime: {
        disabledDate(time) {
          return (
            time.getTime() > new Date(new Date().getFullYear() + "-12-31") ||
            time.getTime() <
              new Date(Number(new Date().getFullYear()) - 1 + "-12-31")
          );
        },
      },
      weeks: weeks,
      months: [],
      editDoing: false,
      //
      copyScheduleDF: false,
      copyScheduleFactories: [],
      copyScheduleObj: {
        ids: [],
      },
      copyScheduleSubmitDoing: false,

      checkAllFactory: false,
      isIndeterminateFactory: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    copySchedule(row) {
      const self = this;
      self.row = row;
      self.copyScheduleObj.ids = [];
      self.copyScheduleFactories = self.factories.filter((f) => f.id != row.id);
      self.copyScheduleSubmitDoing = false;
      self.copyScheduleDF = true;
    },
    handleCheckAllChangeFactory(val) {
      this.copyScheduleObj.ids = val
        ? this.copyScheduleFactories.map((w) => w.id)
        : [];
      this.isIndeterminateFactory = false;
    },
    handleCheckedChangeFactory(value) {
      const checkedCount = value.length;
      this.checkAllFactory = checkedCount === this.copyScheduleFactories.length;
      this.isIndeterminateFactory =
        checkedCount > 0 && checkedCount < this.copyScheduleFactories.length;
    },

    copyScheduleSubmit() {
      const self = this;
      self.$refs.copyScheduleObjForm.validate((valid) => {
        if (valid) {
          self.copyScheduleSubmitDoing = true;
          Factory.copySchedule(self.row.id, self.copyScheduleObj).then(
            function (res) {
              self.copyScheduleSubmitDoing = false;
              self.copyScheduleDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.copyScheduleSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmDelete"))) {
        Factory.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      const self = this;
      this.months = this.computeMonths(31);
      this.row = row;
      this.editObj.name = row.name;
      this.editObj.xcxViewImages = row.xcxViewImages;
      this.editObj.xcxViewPhasePrice = row.xcxViewPhasePrice;
      this.editObj.bulkCapacity = row.bulkCapacity;
      this.editObj.customCapacity = row.customCapacity;
      this.editObj.redundancyPercent = row.redundancyPercent;
      this.editObj.nonWork = row.nonWork;
      // 排程处理
      if (self.Permit.currentTenant().config.mesSchedule == true) {
        if (row.nonWork == null) {
          self.editSelectNonWork = {
            yearHoliday: {
              open: false,
              list: [], // 存日期字符串 01-01, ....12-31
            },
            monthHoliday: {
              open: false,
              list: [], // 存日期字符串 1，2，3....,30 31
            },
            weekHoliday: {
              open: false,
              list: [], // 1:周一 类推 7: 周日
            },
          };
        } else {
          let nonWork = JSON.parse(row.nonWork);
          if (
            nonWork.yearHoliday.list != null &&
            nonWork.yearHoliday.list.length != 0
          ) {
            nonWork.yearHoliday.list = nonWork.yearHoliday.list.map(
              (l) => new Date().getFullYear() + "-" + l
            );
          }
          self.editSelectNonWork = nonWork;
        }
      }
      this.editDoing = false;
      this.editDF = true;
    },
    editScheduleBlur() {
      if (
        this.editObj.bulkCapacity != null &&
        this.editObj.redundancyPercent != null &&
        Util.regexNumber(this.editObj.bulkCapacity)
      ) {
        this.editBulkCapacityAdd =
          (this.editObj.bulkCapacity * this.editObj.redundancyPercent) / 100;
      }
      if (
        this.editObj.customCapacity != null &&
        this.editObj.redundancyPercent != null &&
        Util.regexNumber(this.editObj.customCapacity)
      ) {
        this.editCustomCapacityAdd =
          (this.editObj.customCapacity * this.editObj.redundancyPercent) / 100;
      }
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          // 排程
          if (self.Permit.currentTenant().config.mesSchedule == true) {
            if (
              !Util.regexNumber(self.editObj.bulkCapacity) ||
              self.editObj.bulkCapacity == 0
            ) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("factory.bulkCapacity"),
                ]),
                type: "warning",
              });
              return;
            }
            if (
              !Util.regexNumber(self.editObj.customCapacity) ||
              self.editObj.customCapacity == 0
            ) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("factory.customCapacity"),
                ]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexNumber(self.editObj.redundancyPercent)) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("editObj.redundancyPercent"),
                ]),
                type: "warning",
              });
              return;
            }
            if (
              self.editSelectNonWork.yearHoliday.list != null &&
              self.editSelectNonWork.yearHoliday.list.length != 0
            ) {
              self.editSelectNonWork.yearHoliday.open = true;
              self.editSelectNonWork.yearHoliday.list =
                self.editSelectNonWork.yearHoliday.list.map((l) =>
                  Util.formatDateMD(l)
                );
            } else {
              self.editSelectNonWork.yearHoliday.open = false;
              self.editSelectNonWork.yearHoliday.list == [];
            }
            if (
              self.editSelectNonWork.monthHoliday.list != null &&
              self.editSelectNonWork.monthHoliday.list.length != 0
            ) {
              self.editSelectNonWork.monthHoliday.open = true;
            } else {
              self.editSelectNonWork.monthHoliday.open = false;
              self.editSelectNonWork.monthHoliday.list = [];
            }
            if (
              self.editSelectNonWork.weekHoliday.list != null &&
              self.editSelectNonWork.weekHoliday.list.length != 0
            ) {
              self.editSelectNonWork.weekHoliday.open = true;
            } else {
              self.editSelectNonWork.weekHoliday.open = false;
              self.editSelectNonWork.weekHoliday.list = [];
            }

            if (self.editSelectNonWork.monthHoliday.list.length == 31) {
              self.$message({
                message: "周假期不能全部选择",
                type: "warning",
              });
              return;
            }
            if (self.editSelectNonWork.weekHoliday.list.length == 7) {
              self.$message({
                message: "周假期不能全部选择",
                type: "warning",
              });
              return;
            }

            self.editObj.nonWork = JSON.stringify(self.editSelectNonWork);
          }

          self.editDoing = true;
          Factory.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    add() {
      const self = this;
      this.months = this.computeMonths(31);
      self.addObj.name = null;
      self.addObj.xcxViewImages = false;
      self.addObj.xcxViewPhasePrice = false;
      self.checkedUserIds = [];
      self.addObj.bulkCapacity = null;
      self.addObj.customCapacity = null;
      self.addObj.redundancyPercent = null;
      self.addDoing = false;
      axios
        .all([
          Phase.findByTenantId(),
          User.findByTenantId(self.Permit.currentTenant().id),
        ])
        .then(
          axios.spread(function (phases, users) {
            if (phases.status === 200) {
              self.phasePrices = phases.data.map((p) => {
                return { phaseId: p.id, phaseName: p.name, phasePrice: null };
              });
            } else {
              self.sysError();
            }
            if (users.status === 200) {
              self.users = users.data.filter(
                (u) => u.voidAt == null && u.admin !== true
              );
            } else {
              self.sysError();
            }
            self.addDF = true;
          })
        );
    },
    remove(rowIndex) {
      this.phasePrices.splice(rowIndex, 1);
    },
    addScheduleBlur() {
      if (
        this.addObj.bulkCapacity != null &&
        this.addObj.redundancyPercent != null &&
        Util.regexNumber(this.addObj.bulkCapacity)
      ) {
        this.addBulkCapacityAdd =
          (this.addObj.bulkCapacity * this.addObj.redundancyPercent) / 100;
      }
      if (
        this.addObj.customCapacity != null &&
        this.addObj.redundancyPercent != null &&
        Util.regexNumber(this.addObj.customCapacity)
      ) {
        this.addCustomCapacityAdd =
          (this.addObj.customCapacity * this.addObj.redundancyPercent) / 100;
      }
    },
    addSubmit() {
      const self = this;
      const phasePricesFilter = self.phasePrices.filter(
        (c) => c.phasePrice != null
      );
      for (const pp of phasePricesFilter) {
        if (!Util.regexPrice(pp.phasePrice)) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("factory.phasePrice")]),
            type: "warning",
          });
          return;
        }
      }
      self.addObj.factoryPhases = phasePricesFilter;
      self.addObj.userFactories = self.checkedUserIds.map((c) => {
        return { userId: c };
      });
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          // 排程
          if (self.Permit.currentTenant().config.mesSchedule == true) {
            if (
              !Util.regexNumber(self.addObj.bulkCapacity) ||
              self.addObj.bulkCapacity == 0
            ) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("factory.bulkCapacity"),
                ]),
                type: "warning",
              });
              return;
            }
            if (
              !Util.regexNumber(self.addObj.customCapacity) ||
              self.addObj.customCapacity == 0
            ) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("factory.customCapacity"),
                ]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexNumber(self.addObj.redundancyPercent)) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("editObj.redundancyPercent"),
                ]),
                type: "warning",
              });
              return;
            }
            if (
              self.addSelectNonWork.yearHoliday.list != null &&
              self.addSelectNonWork.yearHoliday.list.length != 0
            ) {
              self.addSelectNonWork.yearHoliday.open = true;
              self.addSelectNonWork.yearHoliday.list =
                self.addSelectNonWork.yearHoliday.list.map((l) =>
                  Util.formatDateMD(l)
                );
            } else {
              self.addSelectNonWork.yearHoliday.open = false;
              self.addSelectNonWork.yearHoliday.list = [];
            }

            if (
              self.addSelectNonWork.monthHoliday.list != null &&
              self.addSelectNonWork.monthHoliday.list.length != 0
            ) {
              self.addSelectNonWork.monthHoliday.open = true;
            } else {
              self.addSelectNonWork.monthHoliday.open = false;
              self.addSelectNonWork.monthHoliday.list = [];
            }

            if (
              self.addSelectNonWork.weekHoliday.list != null &&
              self.addSelectNonWork.weekHoliday.list.length != 0
            ) {
              self.addSelectNonWork.weekHoliday.open = true;
            } else {
              self.addSelectNonWork.weekHoliday.open = false;
              self.addSelectNonWork.weekHoliday.list = [];
            }
            if (self.editSelectNonWork.monthHoliday.list.length == 31) {
              self.$message({
                message: "周假期不能全部选择",
                type: "warning",
              });
              return;
            }
            if (self.editSelectNonWork.weekHoliday.list.length == 7) {
              self.$message({
                message: "周假期不能全部选择",
                type: "warning",
              });
              return;
            }
            self.addObj.nonWork = JSON.stringify(self.addSelectNonWork);
          }
          self.addDoing = true;
          Factory.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    showRow(row) {
      this.currentRecordId = row.id;
      this.showDF = true;
    },

    loadData() {
      const self = this;
      self.loadingStart();
      Factory.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.factories = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    computeHoliday(nonWork, type) {
      if (nonWork == null) {
        return [];
      }
      const nonWorkObj = JSON.parse(nonWork);
      if (type == "yearHoliday") {
        if (nonWorkObj.yearHoliday.open == true) {
          return nonWorkObj.yearHoliday.list;
        }
        return [];
      }
      if (type == "monthHoliday") {
        if (nonWorkObj.monthHoliday.open == true) {
          return nonWorkObj.monthHoliday.list;
        }
        return [];
      }
      if (type == "weekHoliday") {
        if (nonWorkObj.weekHoliday.open == true) {
          return nonWorkObj.weekHoliday.list;
        }
        return [];
      }
    },

    computeMonths(day) {
      let months = [];
      for (let i = 1; i <= day; i++) {
        months.push({ label: i + "号", value: i });
      }
      return months;
    },
  },
};
</script>
<style scoped>
</style>